module.exports = __webpack_public_path__ + "img/the_void.6d30feb5.jpg";